import React from 'react';
import { Link } from 'react-router-dom';

const CustomEACtaBanner = () => {
  return (
    <section className="py-20 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto">
      <div className="relative rounded-2xl bg-surface-container-high border border-white/5 overflow-hidden group">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-transparent"></div>
        <div className="relative p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="max-w-2xl">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>search_check</span>
              </div>
              <h2 className="font-headline-md text-headline-md">Don't See the EA You Need? <span className="text-primary">We'll Get It For You.</span></h2>
            </div>
            <p className="font-body-md text-on-surface-variant mb-0">
              Send us the MQL5 link of any Expert Advisor and we'll source it and list it at our discounted price — typically within 24 hours. No hidden fees, just premium tools at a fraction of the cost.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center relative z-10">
            <Link className="bg-primary-container text-on-primary font-bold px-8 py-4 rounded flex items-center justify-center gap-2 hover:bg-primary transition-all" to="/request">
              Request Custom EA <span className="material-symbols-outlined">arrow_forward</span>
            </Link>
            <a className="flex items-center justify-center gap-3 border border-secondary text-secondary font-bold px-8 py-4 rounded hover:bg-secondary/10 transition-all" href="https://wa.me/919426532062?text=Hello,%20I%20would%20like%20to%20discuss%20a%20custom%20MT4/MT5%20trading%20algorithm%20development%20project." target="_blank" rel="noreferrer">
              <span className="material-symbols-outlined">chat</span> Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomEACtaBanner;
